import AsyncStorage from '@react-native-async-storage/async-storage';

/** Old keys we used to persist spend / household / loan locally. Never read again. */
const LEGACY_PREFIXES = [
  '@budget_analytics_summary_v1:',
  '@budget_analytics_summary_v2:',
  '@budget_household_core_v1',
  '@budget_loan_planner_v1',
];

/** Drop leftover finance snapshots from AsyncStorage (mobile + web). */
export async function purgeLegacyFinanceCaches(): Promise<void> {
  try {
    const keys = await AsyncStorage.getAllKeys();
    const mine = keys.filter((key) =>
      LEGACY_PREFIXES.some((prefix) => key === prefix || key.startsWith(prefix)),
    );
    if (mine.length > 0) {
      await AsyncStorage.multiRemove(mine);
    }
  } catch {
    // Non-fatal
  }
}
